import pelatihan from "../../../assets/images/camera.png";

const event = [
  {
    judul: "cangkul",
    tgl: "22 September 2022",
    jam: "09.00 WIB",
    kategori: "pelatihan",
    img: pelatihan,
  },
  {
    judul: "POPOPO",
    tgl: "22 September 2022",
    jam: "09.00 WIB",
    kategori: "pelatihan",
    img: pelatihan,
  },
  {
    judul: "Pelatihan Digital Marketing",
    tgl: "22 September 2022",
    jam: "09.00 WIB",
    kategori: "pelatihan",
    img: pelatihan,
  },
  {
    judul: "Pelatihan Digital Marketing",
    tgl: "22 September 2022",
    jam: "09.00 WIB",
    kategori: "pelatihan",
    img: pelatihan,
  },
  {
    judul: "Pelatihan Digital Marketing",
    tgl: "22 September 2022",
    jam: "09.00 WIB",
    kategori: "pelatihan",
    img: pelatihan,
  },
  {
    judul: "Pelatihan Digital Marketing",
    tgl: "22 September 2022",
    jam: "09.00 WIB",
    kategori: "pelatihan",
    img: pelatihan,
  },
  {
    judul: "Pelatihan Digital Marketing",
    tgl: "22 September 2022",
    jam: "09.00 WIB",
    kategori: "pelatihan",
    img: pelatihan,
  },
  {
    judul: "Pelatihan Digital Marketing",
    tgl: "22 September 2022",
    jam: "09.00 WIB",
    kategori: "pelatihan",
    img: pelatihan,
  },
  {
    judul: "Pelatihan Digital Marketing",
    tgl: "22 September 2022",
    jam: "09.00 WIB",
    kategori: "pelatihan",
    img: pelatihan,
  },
  {
    judul: "Pelatihan Digital Marketing",
    tgl: "22 September 2022",
    jam: "09.00 WIB",
    kategori: "pelatihan",
    img: pelatihan,
  },
  {
    judul: "Pelatihan Digital Marketing",
    tgl: "22 September 2022",
    jam: "09.00 WIB",
    kategori: "pelatihan",
    img: pelatihan,
  },
  {
    judul: "Pelatihan Digital Marketing",
    tgl: "22 September 2022",
    jam: "09.00 WIB",
    kategori: "pelatihan",
    img: pelatihan,
  },
  {
    judul: "Pelatihan Digital Marketing",
    tgl: "22 September 2022",
    jam: "09.00 WIB",
    kategori: "pelatihan",
    img: pelatihan,
  },
  {
    judul: "Pelatihan Digital Marketing",
    tgl: "22 September 2022",
    jam: "09.00 WIB",
    kategori: "pelatihan",
    img: pelatihan,
  },
  {
    judul: "Pelatihan Digital Marketing",
    tgl: "22 September 2022",
    jam: "09.00 WIB",
    kategori: "pelatihan",
    img: pelatihan,
  },
  {
    judul: "Pelatihan Digital Marketing",
    tgl: "22 September 2022",
    jam: "09.00 WIB",
    kategori: "pelatihan",
    img: pelatihan,
  },
  {
    judul: "Pelatihan Digital Marketing",
    tgl: "22 September 2022",
    jam: "09.00 WIB",
    kategori: "pelatihan",
    img: pelatihan,
  },
  {
    judul: "Pelatihan Digital Marketing",
    tgl: "22 September 2022",
    jam: "09.00 WIB",
    kategori: "pelatihan",
    img: pelatihan,
  },
  {
    judul: "Pelatihan Digital Marketing",
    tgl: "22 September 2022",
    jam: "09.00 WIB",
    kategori: "pelatihan",
    img: pelatihan,
  },
  {
    judul: "Pelatihan Digital Marketing",
    tgl: "22 September 2022",
    jam: "09.00 WIB",
    kategori: "pelatihan",
    img: pelatihan,
  },
];

export default event;
